import { PortableText } from "@portabletext/react"
import { SanityBlock } from "sanity-codegen"
import styles from "./SanityRichTextField.module.css"
import { classNames } from "@punks/ui-core"

export interface RichTextFieldProps {
  value: (SanityBlock & { _key: string })[] | undefined
  className?: string
  multiline?: boolean
}

const SanityRichTextField = ({
  value,
  className,
  multiline,
}: RichTextFieldProps) => {
  if (!value) {
    return <></>
  }
  if (typeof value === "string") {
    return <>{value}</>
  }

  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles.multiline]: multiline,
        },
        className
      )}
    >
      <PortableText value={value} />
    </div>
  )
}

export default SanityRichTextField
